import React, { createContext, useReducer } from "react";

const FilterContext = createContext(null);

const _DEFAUT_STACK = {heap: []};

const urlAndSettings = ({url, settings}) => ({url, settings}); 

const sameUrl = (url) => (current) => current.url === url; 

const stackReducer = ({heap=[]}, action) => {
  switch (action.type) {
    case 'put': {
      const foundAt = heap.findIndex(sameUrl(action.url))
      if (foundAt > -1) {
        heap[foundAt] = urlAndSettings(action);
      } else {
        heap = [urlAndSettings(action), ...heap];
      } 
      return {heap};
    }
    case 'clear': {
      const foundAt = heap.findIndex(sameUrl(action.url))
      if (foundAt > -1) {
         heap.splice(foundAt, 1);
      }
      return {heap};
    }
  }
  throw Error('Unknown action: ' + action.type);
};

const useFilterStack = (defaults=_DEFAUT_STACK) => {
  const [memory, dispatch] = useReducer(stackReducer, defaults);
  const get = url =>
    (memory.heap.find(sameUrl(url)) || {} ).settings;
  const put = (url, settings) =>
    dispatch({type: 'put', url, settings})
  const clear = (url) =>
    dispatch({type: 'clear', url})
  return [get, put, clear]
}

export const FilterContextProvider = ({ children }) => {
  const stackMethods = useFilterStack();
  return (
    <FilterContext.Provider value={stackMethods}>
      {children}
    </FilterContext.Provider>
    
  );
};

export default FilterContext;
